import { useEffect } from 'react';
import TextInput, { InputProps } from 'components/text-input';
import { useIMask } from 'react-imask';
import phone from 'assets/images/phone.svg';

type PhoneInputProps = {} & Omit<InputProps, 'value' | 'icon'>;

const mask = '+7 000 000 0000';

const PhoneInput: React.FC<PhoneInputProps> = (props) => {
  const { onChange, ...rest } = props;

  const { ref, value } = useIMask({ mask });

  useEffect(() => {
    onChange?.(value);
  }, [onChange, value]);

  return <TextInput inputMode='tel' placeholder={mask} icon={phone} ref={ref} {...rest} />;
};

export default PhoneInput;
